    <template>
  <div class="POIinterfacebottom noclick" v-if="markerdata.length > 0">
    <div class>
      <div
        class="btn-group enableclick"
        role="group"
        v-if="poiInterface.infoVisible && markerdata.length > 1 && !poiInterface.profsVisible"
      >
        <button
          class="btn btn-primary btn-sm btn-iconbtn button-h-sm"
          @click="prevpraktijk"
          v-bind:disabled="poiInterface.leftButtonDisabled"
        >
          <i class="fa fa-caret-left caretsize" aria-hidden="true"></i>
        </button>
        <button class="btn btn-primary btn-sm btn-icontextbtn button-h-sm">
          {{ poiInterface.poiselected + 1 }} {{ $store.state.translation[2030] }} {{ markerdata.length }}
        </button>
        <button
          class="btn btn-primary btn-sm btn-iconbtn button-h-sm"
          @click="nextpraktijk"
          v-bind:disabled="poiInterface.rightButtonDisabled"
        >
          <i class="fa fa-caret-right caretsize" aria-hidden="true"></i>
        </button>
      </div>
      <!-- v-if="!showfysioview" -->
      <div class="infoview praktijkview enableclick selecttext scrollInterfacePoi" v-if="!poiInterface.profsVisible">
        <div class="fysiodatawrap praktijkview">
          <fieldset>
            <div class="row">
              <div :class="colsizepraktijkview">
                <div class="infoviewhead">{{ markerdata[poiInterface.poiselected].tblPointOfInterestName }}</div>
                <address>
                  <div class="poiadres">
                    <font-awesome-icon :icon="['far', 'map-marker-alt']" class="poimarkers" />
                    {{ markerdata[poiInterface.poiselected].tblPointOfInterestStreet }}
                    {{ markerdata[poiInterface.poiselected].tblPointOfInterestNumber }}
                    {{ markerdata[poiInterface.poiselected].tblPointOfInterestNumberAddition }}
                  </div>

                  <div class="poiadres2">
                    {{ markerdata[poiInterface.poiselected].tblPointOfInterestPostalCode }}
                    {{ markerdata[poiInterface.poiselected].tblPointOfInterestCity }}
                  </div>

                  <div class="poitelnr">
                    <font-awesome-icon :icon="['fas', 'mobile-alt']" class="poimarkers" />
                    <!-- hier stond eerst in <a v-bind:href="markerdata[poiInterface.poiselected].tblPointOfInterestTelephone">hier {{markerdata etc.}}</a> -->
                    {{ markerdata[poiInterface.poiselected].tblPointOfInterestTelephone }}
                  </div>
                  <br />
                  <div
                    class="poiwebsite"
                    @click="clickpoiwebsite(markerdata[poiInterface.poiselected].tblPointOfInterestWebsite)"
                  >
                    <font-awesome-icon icon="globe" transform="grow-10" class="poiGlobeicon" />
                    <br />
                    <span class="capitaltext">{{ translation(15345) }}</span>
                    <!-- <a
                      v-if="markerdata[poiInterface.poiselected].tblPointOfInterestWebsite"
                      target="_blank"
                      v-bind:href="markerdata[poiInterface.poiselected].tblPointOfInterestWebsite"
                    >{{$store.state.translation[8944]}}</a>-->
                  </div>
                  <div
                    class="poiemail"
                    @click="clickpoiemail(markerdata[poiInterface.poiselected].tblPointOfInterestEmail)"
                  >
                    <font-awesome-icon :icon="['far', 'envelope']" transform="grow-10" class="poiEnvelopeicon" />
                    <br />
                    <span class="capitaltext">{{ translation(15346) }}</span>
                    <!-- <a
                      v-if="markerdata[poiInterface.poiselected].tblPointOfInterestEmail"
                      v-bind:href="'mailto:' + markerdata[poiInterface.poiselected].tblPointOfInterestEmail"
                    >{{$store.state.translation[14164]}}</a>-->
                  </div>
                </address>
              </div>

              <div class="col-md-6 col-sm-6 col-xs-12" v-if="pnlAlgBeoordelingVisible">
                <div class="row pnlAlgBeoordeling">
                  <div class="col-md-8 pnlbeoordelingheader">
                    <span>{{ translation(15344) }}</span>
                    <br />
                    <span class="spanAantalPersonen" v-if="aantalpersonenvisible">{{
                      translation(15400) + ' ' + aantalpersonen + ' ' + translation(15401)
                    }}</span>
                  </div>
                  <div class="col-md-4 colRing">
                    <div class="ring" :style="{ borderColor: ringColor }">
                      {{ ringcontent }}
                      <span></span>
                    </div>
                  </div>
                </div>
                <div class="row pnlscore" v-if="pnlscorevisible">
                  <div class="col-md-12 pnlscoreheader">NPS Score</div>
                </div>
                <div class="row pnlNPSprogressbar" v-if="pnlscorevisible">
                  <div class="col-md-12">
                    <div class="NPSprogress-container">
                      <div class="NPSprogress-bar" :style="{ width: npswidth }">
                        <div class="NPSprogressarrowgroup pull-right">
                          <div class="NPSprogressarrowup">
                            <font-awesome-icon icon="caret-down" class="fa-rotate-180" />
                          </div>
                          <div class="NPSprogressarrowtext">
                            <b>{{ npsscoretext }}</b>
                          </div>
                          <div class="NPSprogressarrowdown">
                            <font-awesome-icon icon="caret-down" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="NPSprogress-container2">
                      <div class="NPSprogresslegenda" :style="{ width: '100%' }">
                        <div class="NPSprogressarrowgroup pull-right">100</div>
                      </div>
                      <div class="NPSprogresslegenda" :style="{ width: '75%' }">
                        <div class="NPSprogressarrowgroup pull-right">50</div>
                      </div>
                      <div class="NPSprogresslegenda" :style="{ width: '50%' }">
                        <div class="NPSprogressarrowgroup pull-right">0</div>
                      </div>
                      <div class="NPSprogresslegenda" :style="{ width: '25%' }">
                        <div class="NPSprogressarrowgroup pull-right">-50</div>
                      </div>
                      <div class="NPSprogresslegenda" :style="{ width: '0%' }">
                        <div class="NPSprogressarrowgroup pull-right">-100</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row pnlSource margin10" v-if="pnlSourceVisible">
                  <div class="col-md-12">
                    <XVhelpcontrol :helptext="aanbiedergegevensHC" class="aanbiedergegevensHC pointer"></XVhelpcontrol>
                    <span class="pointer">
                      &nbsp;{{ translation(15343) }}
                      <a @click="aanbiedergegevensURL()">{{ naamAanbiedergegevens }}</a>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      <div class="infoview enableclick">
        <button
          type="button"
          @click.prevent="showProfs(markerdata[poiInterface.poiselected].tblPointOfInterestID)"
          class="btn btn-primary btn-sm button-h-sm btn-icontextbtn btn-block"
        >
          <i
            class="fa caretsize pull-left poscaret-down"
            :class="[poiInterface.profsVisible ? 'fa-caret-down' : 'fa-caret-up']"
            aria-hidden="true"
          ></i>
          <span>{{ $store.state.translation[14133] }}</span>
        </button>

        <div v-if="poiInterface.profsVisible">
          <div v-if="poiProf.length != 0" class="col-md-12 scrollInterfacePoi">
            <div v-for="(prof, index) in poiProf" :key="'prof' + index" class="margin20">
              <p>
                <font-awesome-icon :icon="['fas', 'user']" size="lg" />&nbsp;
                <strong>{{ prof.tblPersonName }}</strong>
              </p>
              <p v-for="(meta, index2) in poiProfMeta(prof.tblPersonID)" :key="'meta' + index2">
                <span>{{ meta.metaName }}:</span>
                <span v-if="meta.metaName !== 'Specialismen'">{{ meta.tblPersonInfoRequiredValueValue }}</span>
                <template
                  v-if="meta.metaName === 'Specialismen' && meta.tblPersonInfoRequiredValueValue.indexOf(';') !== -1"
                >
                  <span
                    v-for="(spec, index3) in metaspecialisme(meta.tblPersonInfoRequiredValueValue)"
                    :class="'SKF_' + meta.metaName"
                    :key="index3"
                    >{{ spec }}</span
                  >
                </template>
                <span
                  v-if="meta.metaName === 'Specialismen' && meta.tblPersonInfoRequiredValueValue.indexOf(';') === -1"
                  :class="'SKF_' + meta.metaName"
                  >{{ meta.tblPersonInfoRequiredValueValue }}</span
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
    <script>
'use strict'

import { mapGetters, mapActions, mapMutations } from 'vuex'
import { FAMixin } from 'pevueglobal'
export default {
  mixins: [FAMixin],
  props: {
    markerdata: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {}
  },
  created() {},
  methods: {
    ...mapActions('SKFPraktijken', ['PEapi_PointsOfInterest_Profs']),
    ...mapMutations('SKFPraktijken', [
      'leftButtonDisabled',
      'rightButtonDisabled',
      'poiSelectedIncrease',
      'poiSelectedDecrease',
      'profSelectedIncrease',
      'profSelectedDecrease',
      'toggleProfsVisible',
    ]),
    showProfs(poiID) {
      if (this.poiInterface.profsVisible === true) {
        this.toggleProfsVisible(false)
      } else {
        this.PEapi_PointsOfInterest_Profs({ poiID })
      }
    },
    nextpraktijk: function () {
      if (this.poiInterface.poiselected < this.markerdata.length - 1) {
        if (this.poiInterface.poiselected === this.markerdata.length - 2) {
          this.rightButtonDisabled(true)
        }
        this.leftButtonDisabled(false)

        this.poiSelectedIncrease()
      } else {
        this.rightButtonDisabled(true)
      }
    },
    prevpraktijk: function () {
      if (this.poiInterface.poiselected > 0) {
        this.poiSelectedDecrease()
        if (this.poiInterface.poiselected === 0) {
          this.leftButtonDisabled(true)
        }
        this.rightButtonDisabled(false)
      } else {
        this.leftButtonDisabled(true)
      }
    },
    metaspecialisme(tblPersonInfoRequiredValueValue) {
      let semicolon = tblPersonInfoRequiredValueValue.indexOf(';')
      if (semicolon !== -1) {
        let specialisatie = tblPersonInfoRequiredValueValue.split(';')
        return specialisatie
      }
    },
    clickpoiwebsite(url) {
      window.open(url, '_blank')
    },
    clickpoiemail(mail) {
      window.location.href = 'mailto:' + mail
    },
    aanbiedergegevensURL() {
      let npsScore = this.markerdata[this.poiInterface.poiselected].npsdata.data.filter((s) => {
        return s.tblPOIInfoRequiredID === 1950
      })
      if (npsScore[0].tblPOIInfoRequiredPosValueExtKey === 'ZorgDNA') {
        window.open(this.translation(15311), '_blank')
      } else if (npsScore[0].tblPOIInfoRequiredPosValueExtKey === 'Mediquest') {
        window.open(this.translation(15313), '_blank')
      } else if (npsScore[0].tblPOIInfoRequiredPosValueExtKey === 'Qualizorg') {
        window.open(this.translation(15695), '_blank')
      }
    },
  },
  computed: {
    ...mapGetters('SKFPraktijken', ['poiInterface', 'poiProf', 'poiProfMeta']),
    colsizepraktijkview() {
      let premScoreAverage = this.markerdata[this.poiInterface.poiselected].npsdata.data.filter((s) => {
        return s.tblPOIInfoRequiredID === 1945
      })
      if (premScoreAverage[0].tblPOIInfoRequiredValueValue) {
        return 'col-md-6 col-sm-6 col-xs-12'
      } else {
        return 'col-md-offset-3 col-md-6 col-sm-offset-3 col-sm-6 col-xs-12'
      }
    },
    pnlAlgBeoordelingVisible() {
      let premScoreAverage = this.markerdata[this.poiInterface.poiselected].npsdata.data.filter((s) => {
        return s.tblPOIInfoRequiredID === 1945
      })
      if (premScoreAverage[0].tblPOIInfoRequiredValueValue) {
        return true
      } else {
        return false
      }
    },
    ringcontent() {
      let premScoreAverage = this.markerdata[this.poiInterface.poiselected].npsdata.data.filter((s) => {
        return s.tblPOIInfoRequiredID === 1945
      })
      return premScoreAverage[0].tblPOIInfoRequiredValueValue
    },
    aantalpersonen() {
      let premScoreAverage = this.markerdata[this.poiInterface.poiselected].npsdata.data.filter((s) => {
        return s.tblPOIInfoRequiredID === 1949
      })
      return premScoreAverage[0].tblPOIInfoRequiredValueValue
    },
    aantalpersonenvisible() {
      let premScoreAverage = this.markerdata[this.poiInterface.poiselected].npsdata.data.filter((s) => {
        return s.tblPOIInfoRequiredID === 1949
      })
      if (premScoreAverage[0].tblPOIInfoRequiredValueValue) {
        return true
      } else {
        return false
      }
    },
    ringColor() {
      let premScoreAverage = this.markerdata[this.poiInterface.poiselected].npsdata.data.filter((s) => {
        return s.tblPOIInfoRequiredID === 1945
      })
      let valueinpercentage = premScoreAverage[0].tblPOIInfoRequiredValueValue * 10
      const hue = Math.round(valueinpercentage)
      return ['hsl(', hue, ', 50%, 50%)'].join('')
    },
    pnlscorevisible() {
      let npsScore = this.markerdata[this.poiInterface.poiselected].npsdata.data.filter((s) => {
        return s.tblPOIInfoRequiredID === 1941
      })
      if (npsScore[0].tblPOIInfoRequiredValueValue) {
        return true
      } else {
        return false
      }
    },
    npswidth() {
      let npsScore = this.markerdata[this.poiInterface.poiselected].npsdata.data.filter((s) => {
        return s.tblPOIInfoRequiredID === 1941
      })
      let npsscorevalue = npsScore[0].tblPOIInfoRequiredValueValue
      if (npsscorevalue >= 0) {
        let npsscorepercentage = 50 + npsscorevalue / 2
        return npsscorepercentage + '%'
      } else if (npsscorevalue < 0) {
        let negativescorecalc = Math.abs(npsscorevalue / 2)
        let npsscorepercentage = 50 - negativescorecalc
        return npsscorepercentage + '%'
      } else {
        return ''
      }
    },
    npsscoretext() {
      let npsScore = this.markerdata[this.poiInterface.poiselected].npsdata.data.filter((s) => {
        return s.tblPOIInfoRequiredID === 1941
      })
      return npsScore[0].tblPOIInfoRequiredValueValue
    },
    naamAanbiedergegevens() {
      let npsScore = this.markerdata[this.poiInterface.poiselected].npsdata.data.filter((s) => {
        return s.tblPOIInfoRequiredID === 1950
      })
      return npsScore[0].tblPOIInfoRequiredValueValue
    },

    aanbiedergegevensHC() {
      let npsScore = this.markerdata[this.poiInterface.poiselected].npsdata.data.filter((s) => {
        return s.tblPOIInfoRequiredID === 1950
      })
      if (npsScore[0].tblPOIInfoRequiredPosValueExtKey === 'ZorgDNA') {
        return this.translation(15310)
      } else if (npsScore[0].tblPOIInfoRequiredPosValueExtKey === 'Mediquest') {
        return this.translation(15312)
      } else if (npsScore[0].tblPOIInfoRequiredPosValueExtKey === 'Qualizorg') {
        return this.translation(15694)
      } else {
        return ''
      }
    },
    pnlSourceVisible() {
      let npsScore = this.markerdata[this.poiInterface.poiselected].npsdata.data.filter((s) => {
        return s.tblPOIInfoRequiredID === 1950
      })
      if (npsScore[0].tblPOIInfoRequiredValueValue) {
        return true
      } else {
        return false
      }
    },
  },
}
</script>
<style scoped>
.SKF_Specialismen {
  background-color: #eee;
  border-radius: 4px;
  cursor: pointer;
  margin: 2px 3px;
  position: relative;
  padding: 4px 6px 4px 6px;
}
.praktijkview fieldset {
  border-color: #fff;
}
.infoviewhead {
  padding-left: 20px;
  margin-bottom: 10px;
}
address {
  padding-left: 20px;
}
.googlemapsapp,
.fysiodatawrap {
  text-align: left;
}
.poiadres2 {
  text-indent: 12px;
}
.poiadres2,
.poiadres,
.poitelnr,
.pnlSource,
.NPSprogresslegenda,
.spanAantalPersonen {
  color: #707070;
  font-size: 12px;
}
.NPSprogresslegenda {
  display: flex;
  position: absolute;
}
.poiwebsite,
.poiemail {
  height: 60px;
  width: 46%;
  background-color: #eee;
  cursor: pointer;
  padding: 14px;
  text-align: center;
}
.poiwebsite {
  float: left;
  margin-right: 10px;
}
.poiemail {
  overflow: hidden;
}
.poimarkers {
  color: black;
}
.ring {
  position: absolute;
  top: 0;
  left: 0;
  width: 85px;
  height: 85px;
  background: transparent;
  border: 6px solid #3c3c3c;
  border-radius: 50%;
  text-align: center;
  line-height: 71px;
  font-family: sans-serif;
  font-size: 30px;
  color: #000;
}
.colRing {
  height: 85px;
  margin-top: 10px;
}
.pnlbeoordelingheader,
.pnlscoreheader {
  margin-top: 10px;
  font-size: 15px;
}

.NPSprogress-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  /* padding-top: 8px; */
  /* padding-bottom: 8px; */
  border-radius: 6px;
  height: 30px;
  background: rgb(255, 0, 0);
  background: linear-gradient(
    90deg,
    rgba(255, 0, 0, 1) 0%,
    rgba(255, 162, 0, 1) 25%,
    rgba(232, 178, 0, 1) 50%,
    rgba(34, 198, 15, 1) 77%,
    rgba(28, 147, 0, 1) 100%
  );
}
.NPSprogress-container2 {
  position: relative;
  height: 20px;
}

.NPSprogress-bar {
  display: flex;
}
.NPSprogressarrowup,
.NPSprogressarrowdown {
  height: 10px;
  line-height: 0;
}
.NPSprogressarrowtext {
  height: 9px;
  line-height: 10px;
}
.NPSprogressarrowgroup {
  text-align: center;
  margin-left: auto;
}
.NPSprogress0 {
  width: 0%;
  position: absolute;
}
.NPSprogress25 {
  width: 25%;
  text-align: right;
  position: absolute;
}
.NPSprogress50 {
  width: 50%;
  text-align: right;
  position: absolute;
}
.NPSprogress75 {
  width: 75%;
  text-align: right;
  position: absolute;
}
.NPSprogress100 {
  width: 100%;
  text-align: right;
}
.NPSprogresslegenda {
  width: 100%;
}
.poiEnvelopeicon,
.poiGlobeicon {
  margin-bottom: 5px;
}
.capitaltext {
  text-transform: capitalize;
}

/* bootstrap pixels aangehouden */
@media (max-width: 768px) {
  .pnlbeoordelingheader,
  .pnlscore {
    border-top: 1px solid #eee;
    text-align: center;
    padding-top: 10px;
    margin-top: 20px;
  }
  .ring {
    margin-left: auto;
    margin-right: auto;
    position: inherit;
  }
  address,
  .infoviewhead {
    padding-left: 0;
  }
}
</style>
<style>
.aanbiedergegevensHC .graphQuestion {
  margin-bottom: 0 !important;
}
</style>
                                    
